import { createContext, useContext } from 'react';

export interface ChartError {
  chartId: string;
  chartTitle?: string;
  chartType: string;
  metric?: string;
  secondaryDimension?: string;
  reason:
    | 'no_data_provider'
    | 'chart_not_supported'
    | 'data_fetch_error'
    | 'unknown';
  timestamp: number;
}

interface ChartErrorContextValue {
  errors: ChartError[];
  reportError: (error: Omit<ChartError, 'timestamp'>) => void;
  clearErrors: () => void;
  clearError: (chartId: string) => void;
  hasErrors: boolean;
}

const ChartErrorContext = createContext<ChartErrorContextValue | null>(null);

function useChartErrors() {
  const context = useContext(ChartErrorContext);
  if (!context) {
    // Return no-op functions when not in provider (for non-AI preview contexts)
    return {
      errors: [],
      reportError: () => {
        // No-op: not in ChartErrorProvider context
      },
      clearErrors: () => {
        // No-op: not in ChartErrorProvider context
      },
      clearError: () => {
        // No-op: not in ChartErrorProvider context
      },
      hasErrors: false,
    };
  }
  return context;
}

export function useReportChartError() {
  const { reportError } = useChartErrors();
  return reportError;
}
